// console.log FOR EVERYONE http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

jQuery.fn.setAllToMaxHeight = function(){
   return this.height( Math.max.apply(this, jQuery.map( this , function(e){ return jQuery(e).height() }) ) );
}

if (true) {
    slideDuration = 8000;
} else {
    slideDuration = 0;
}


function showBackTop(posTop){
    if (posTop > 200) {
        $('#back-top').fadeIn(200);
    } else {
        $('#back-top').fadeOut(200);
    } 
}


function doResize(){
   $('body#index ul.collection-list .thumbnail').removeAttr("style").setAllToMaxHeight();
   //$('ul.collection-th .thumbnail').removeAttr("style").setAllToMaxHeight();
   $('ul.collection-th li a.prod-th').removeAttr("style").setAllToMaxHeight();    
}


// resize but not too often
var resizeDelay;
$(window).resize(function() {
    clearTimeout(resizeDelay);
    resizeDelay = setTimeout(function() {
        doResize();
    }, 50);
});


//ipad refresh on rotate
/*
if (window.addEventListener) {
    window.addEventListener("orientationchange", function() {
        window.location.reload();
    }, false);
}
*/

// preload images
$.fn.preload = function() {
    this.each(function(){
        $('<img/>')[0].src = this;
    });
}



jQuery(document).ready(function($){

    $('ul.collection-th .thumbnail').imagesLoaded( function() {
        //images have loaded
        doResize();
    });  

    $(document).on('click', '#menu .top-search .icon-magnifier', function(){
        var $topSearch = $('#menu .top-search');
        $topSearch.toggleClass('active');
        if ($topSearch.hasClass("active")){
            $topSearch.find('input').focus();
        }
    });
  
    function shappify_update_message(){
       
    }


    $(document).on('click', "span.quick-view", function(e){ 
        e.preventDefault();
        e.stopPropagation();
        $.magnificPopup.open({
            items: {
              src: $(this).data('prdid'),
              type: 'inline'
            
            }
        });  
      	shappify_update_message();
    }); 
  
    $(document).on('click', "img.quick-view-img", function(e){ 
        e.preventDefault();
        e.stopPropagation();
        $.magnificPopup.open({
            items: {
              src: $(this).data('prdid'),
              type: 'inline'
            
            }
        });  
      	shappify_update_message();
    });
  
    $(document).on('click', "span.quick-view-span", function(e){ 
        e.preventDefault();
        e.stopPropagation();
        $.magnificPopup.open({
            items: {
              src: $(this).data('prdid'),
              type: 'inline'
            
            }
        });  
      	shappify_update_message();
    });

    if ($(window).width() > 900) {  
        $(".prod-th").mouseenter(function(e){
            $(".quick-view").hide();
            $(".quick-view", this).stop().fadeIn(300);
        }).mouseleave(function(e){
            $(".quick-view").hide();
        });    
    }  

    var $mobileNav = $("<div class='mobile-nav'><a class='mobile-button' id='show-nav' href='#'><span class='icon-list'></span> MENU</a><a class='mobile-button' id='mini-cart' href='/cart'><span class='icon-cart3'></span>CART</a></div>");
    var $menu = $("#menu");
    // clone menu for mobile and remove id
    var $newNav = $menu.clone();
    $newNav.removeAttr('id');
    $newNav.addClass('mobile-menu');
    $mobileNav.append($newNav);

    $("body").prepend($mobileNav);
    
    $newNav.find('li.has-sub > a').each(function() {
        var tis = $(this);
        var state = false;
        var subMenu = tis.next('ul').slideUp();
        tis.on('click', function(e) {
            e.preventDefault();
            state = !state;
            subMenu.slideToggle(state);
            tis.closest('li').toggleClass('active',state);
        });
    });   

    $('#show-nav').on('click', function() {
        $("ul.mobile-menu").slideToggle();
    });  

    function initMenu(){
        $menu.find('.open').removeClass('open');
    }

    $(document).on('click', '#menu.click-me .has-sub > a', function(e){
        // handle desktop menu clicks
        e.preventDefault();
        e.stopPropagation();
        $this = $(this);
        $thisParent = $this.parent();
        if ($thisParent.hasClass('level-1')){
            if ($thisParent.hasClass('open')){
                initMenu();
            } else {
                initMenu();
                $thisParent.addClass('open');
                $this.next('ul').toggleClass('open');            
            }
        } else {
            if ($this.next('ul').hasClass('open')){
                // hide the sub attached to this link
                $thisParent.find('ul').removeClass('open');
            } else {
                // close any open subs and then open sub attached to this link
                $this.closest('ul.open').find('ul').removeClass('open');
                $this.next('ul').addClass('open');
            }
        }
    });   
  
    var $slides = $('#slides');
  
   if($slides.find("div").length === 1){
      $slides.parent().addClass('single-slide');
    }

    $slides.before("<div class='slide-prev'><span class='icon-arrow-large-left'></span></div><div class='slide-next'><span class='icon-arrow-large-right'></span></div>");
    $slides.after("<div class='slide-pager'></div>");

    $slides.find('img').each(function(){
        $('#slideshow .slide-pager').append("<a href='#'></a>");
    });

    $slides.on( 'cycle-initialized', function(event, optionHash) {
        //not needed
    });	


    $slides.on( 'cycle-update-view', function( e, opts ) {
        // show captions
        var currSlide = $(this);
        currSlide.find('.caption1').addClass('animate1');
        currSlide.find('.caption2').addClass('animate2');		
        currSlide.find('.cta').addClass('animate2');		
    });	
	
    $slides.on( 'cycle-before', function( e, opts ) {
        // hide captions
        var slideshow = $(this);
        var img = slideshow.find('.caption').removeClass('animate1').removeClass('animate2');
    });		
	
    $slides.cycle({
        timeout: slideDuration,
        fx: 'scrollHorz',     
        slides: '.slide',
        prev: '.slide-prev',
        next: '.slide-next',
        pager: '#slideshow .slide-pager',
        swipe: true,
        easing: 'easeOutQuint',
        pagerTemplate: ''
    });    

    if (false){
        // get top offset of menu 
        var menuOffset = $('#menu').offset().top;
        var stickyNav = function(){
            var scrollTop = $(window).scrollTop();
            if (scrollTop > menuOffset) { 
                $('#menu').addClass("fixed");
            } else {
                $('#menu').removeClass("fixed");
            }   
        }
        // position menu on load
        stickyNav();  
    }
    
    $(window).scroll(function() {
        showBackTop($(this).scrollTop());
        if (false){
            stickyNav();
        }
    });

    // Animate the scroll to top
    $('#back-top').on('click', function(event) {
        event.preventDefault();
        $('html, body').animate({scrollTop: 0}, 300);
    });    


    // Gallery for product with single image
    $('#product-images.single-image #product-shot').magnificPopup({
        type: 'image'
    });
  
    // Gallery for product with multiple images
    var prdImages = [];
    var $prdImg = $('#more-images a');
    $prdImg.each(function(){
        prdImages.push({
            src: $(this).prop('href'),
            title: $(this).find('img').prop('alt'),
          	type: $(this).attr("data-type")
        });  
    });

    $('#product-images.multi-image #product-shot').on('click',function(e){
        // show lightbox popup for all images 
        e.preventDefault();
        $.magnificPopup.open({
            items: prdImages,
            delegate: 'a',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
          	
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            },
      
    
        	iframe : {
                markup: '<div class="mfp-iframe-scaler">'+
                          '<div class="mfp-close"></div>'+
                          '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                        '</div>',
                patterns: {
                  youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: '//www.youtube.com/embed/%id%?autoplay=1' 
                  },
                  vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                  },
                  gmaps: {
                    index: '//maps.google.',
                    src: '%id%&output=embed'
                  }
                },
                srcAction: 'iframe_src',
              }	
          
            
        });  
    });
  
    // preload gallery images  
    var galleryImg = [];
    // Select all images used in the image swap function - in our case class "img-swap"
    $("#more-images a").each(function(){
        imgUrl = $(this).prop("href");
        galleryImg.push(imgUrl);
    });
    // Pass the array to our preload function
    $(galleryImg).preload(); 
  
  	function YouTubeGetID(url){
       url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
       return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
    }
  
    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
  
  
    $("#more-images a").on('click',function(e){
        // swap main image when a thumb is clicked
        e.preventDefault();  
        var variant = getParameterByName('variant');

        var href = $(this).prop('href');
        var typevar = $(this).attr("data-type");
       
        $("#more-images a").removeClass('active-img');
        $(this).addClass('active-img');
      	if(typevar == 'image'){
          	$('#product-shot').find('img').prop('src',href);
          	$("#image-product").css('display','');
            $("#image-product").css('display','');
          	$(".sticker-new").css('display','');
            $(".sticker-sale").css('display','');
            $("#ifrm").remove();
      	}else if(typevar == 'iframe'){
          	$("#ifrm").remove();
          	var hrefIframe = YouTubeGetID(href);
          	var endHref = 'https://www.youtube.com/embed/'+hrefIframe;
          	
            var ifrm = document.createElement('iframe');
            ifrm.setAttribute('id', 'ifrm'); // assign an id
            var el = document.getElementById('id-iframe');
            el.parentNode.insertBefore(ifrm, el);
            ifrm.setAttribute('src', endHref);
          	ifrm.setAttribute("width", "333px");
			ifrm.setAttribute("height", "300px");
            $("#image-product").css('display','none');
            $(".sticker-new").css('display','none');
            $(".sticker-sale").css('display','none');
            $(".icon-magnifier").css('display','none');
      	}
        
        
    });
  
    

    $('a.go-back').on('click', function(e) {
        e.preventDefault();
        javascript:history.back();
    });  

    $('a.cart-update').on('click', function(e) {
        e.preventDefault();
        $('form#cartform').submit(); 
    });  
   
    $("#content").fitVids(); 

    // hide big footer if no content  
    var $bigFooter = $('.social-row .inner > div');
    var bigFootCnt = $bigFooter.find("div").length;
    if (bigFootCnt === 0){
        $('.social-row').hide();
    }
    
    $('.social-icons a').prop('target','_blank');
  
    
     
    
 
    
    var owl = $("#more-images");
    owl.owlCarousel({
       itemsCustom : [
          [0, 1],
          [320, 2],   
          [640, 3]
       ],  
       items : 3,
       rewindSpeed : 400,   
       navigation:true,
       navigationText : ["<span class='icon-arrow-large-left'></span>","<span class='icon-arrow-large-right'></span>"]   
    });
     
    RESPONSIVEUI.responsiveTabs();  
     
    $('.gt-accordion h4').each(function() {
       var tis = $(this), state = false, answer = tis.next('div').slideUp();
       tis.click(function() {
          state = !state;
          answer.slideToggle(state);
          tis.toggleClass('active',state);
       });
    });      
     
     
        $('#review-summary').on('click',function(e){
            e.preventDefault();
            var target = "#shopify-product-reviews";
            $('html, body').animate({
               scrollTop: $(target).offset().top
            }, 1200);
          console.log("clicked");
         });     
     
// product variant callback
var currencyFormat = $('body').data('curr-format');
selectCallback = function(variant, selector) {
  var $product = $('#prod-' + selector.product.id);
  $('.var-msg', $product).html('').hide();

  if (variant && variant.available == true) {
    // update featured image
    if(variant.featured_image != null){
      var variantImageId = variant.featured_image.id || {};
      $('#'+variantImageId).trigger("click");
    }

    // enable buy button
    $('.purchase', $product).removeClass('disabled').removeAttr('disabled');
    // Update the price and compare at price.
    $('.product-price', $product).html(Shopify.formatMoney(variant.price, currencyFormat));
    if ( variant.compare_at_price > variant.price ) {
        $('.product-compare-price', $product).html(Shopify.formatMoney(variant.compare_at_price, currencyFormat));
    } else {
        $('.product-compare-price', $product).html('');
    }
    // Update the SKU
    var $sku = $('.variant-sku', $product);
    if ($sku.length > 0) {
        if (variant.sku) {
            $sku.text(variant.sku);
            $sku.parent('.sku-container').css('visibility', 'visible');
        } else {
            $sku.parent('.sku-container').css('visibility', 'hidden');
        }
    }
  } else {
    // disable buy button
    $('.purchase', $product).addClass('disabled').attr('disabled', 'disabled');
    // Update the price and compare at price.
    $('.product-price', $product).html('');
    $('.product-compare-price', $product).html('');
    // Update the SKU
    var $sku = $('.variant-sku', $product);
    if ($sku.length > 0) {
        if (variant) {
            if (variant.sku) {
                $sku.text(variant.sku);
                $sku.parent('.sku-container').css('visibility', 'visible');
            } else {
                $sku.parent('.sku-container').css('visibility', 'hidden');
            }
        } else {
            $sku.parent('.sku-container').css('visibility', 'hidden');
        }
    }

    // update featured image
    if(variant && variant.featured_image != null){
      var variantImageId = variant.featured_image.id || {};
      $('#'+variantImageId).trigger("click");
    }

    // show out of stock message
    var msg = variant ? "Out of Stock" : "Unavailable";
    $('.var-msg', $product).html(msg).fadeIn(200);
  }
};



  

    selectCallback2 = function(variant, selector) {	
        var $product = $('#prod2-' + selector.product.id);
        $('.var-msg', $product).html('').hide();
        if (variant && variant.available == true) {
          	if(variant.featured_image != null){
              var variantImageId = variant.featured_image.id || {};
              $('#'+variantImageId).trigger("click");
            }
            // enable buy button
            $('.purchase', $product).removeClass('disabled').removeAttr('disabled');
            // Update the price and compare at price.
            $('.product-price', $product).html(Shopify.formatMoney(variant.price, currencyFormat));          
            if ( variant.compare_at_price > variant.price ) {
                $('.product-compare-price', $product).html(Shopify.formatMoney(variant.compare_at_price, currencyFormat));
            } else {
                $('.product-compare-price', $product).html('');
            }
        } else {
            var msg = variant ? "Sold Out" : "Out of Stock";    
            $('.product-price', $product).html('');
            $('.product-compare-price', $product).html('');
            $('.var-msg', $product).html(msg).fadeIn(200);
            $('.purchase', $product).addClass('disabled').attr('disabled', 'disabled');
        }
    };

});


